import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SessionService } from '../../services/session.service';
import { PageComponent } from '../../components/page/page.component';
import { RouteUtil } from 'src/app/general/util/route-util';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationStatus } from '../../util/util';
import { Util } from 'src/app/general/util/util';
import { ActionComponent } from 'src/app/general/components/action/action.component';
import { TranslateModule } from '@ngx-translate/core';
import { DeviceEventsComponent } from '../../components/device-events/device-events.component';
import { DeviceHeaderComponent } from '../../components/device-header/device-header.component';

@Component({
  selector: 'app-device-events-page',
  standalone: true,
  imports: [
    CommonModule,
    DeviceEventsComponent,
    PageComponent,
    DeviceHeaderComponent,
    ActionComponent,
    TranslateModule
  ],
  templateUrl: './device-events-page.component.html',
  styleUrls: ['./device-events-page.component.css']
})
export class DeviceEventsPageComponent implements OnInit {

  deviceId: string;

  constructor(
      private sessionService: SessionService,
      private activatedRoute: ActivatedRoute) {
    this.deviceId = '';
  }

  ngOnInit(): void {
    if (this.sessionService.enforceAuthentication()
        == AuthenticationStatus.USER_NOT_AUTHENTICATED_AND_REDIRECTED_TO_SIGNIN_PAGE) {
      return;
    }

    const pathParams = RouteUtil.getPathParams(this.activatedRoute);
    this.deviceId = Util.safeString(pathParams.get('deviceId'));
  }
}
